function onlyDigits(value: string): string {
  return value.replace(/\D/g, "");
}

function hasRepeatedDigits(value: string): boolean {
  return /^(\d)\1+$/.test(value);
}

function calculateCheckDigit(value: string, weights: number[]): number {
  const sum = weights.reduce((acc, weight, index) => acc + Number(value[index]) * weight, 0);
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

function isValidCpf(value: string): boolean {
  if (value.length !== 11 || hasRepeatedDigits(value)) return false;

  const firstDigit = calculateCheckDigit(value, [10, 9, 8, 7, 6, 5, 4, 3, 2]);
  const secondDigit = calculateCheckDigit(value, [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);

  return firstDigit === Number(value[9]) && secondDigit === Number(value[10]);
}

function isValidCnpj(value: string): boolean {
  if (value.length !== 14 || hasRepeatedDigits(value)) return false;

  const firstDigit = calculateCheckDigit(value, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const secondDigit = calculateCheckDigit(value, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

  return firstDigit === Number(value[12]) && secondDigit === Number(value[13]);
}

export function isValidCpfOrCnpj(value: string): boolean {
  const document = onlyDigits(value);
  return isValidCpf(document) || isValidCnpj(document);
}
